import { gql } from '@apollo/client';

export interface ILibraryCategoryShop {
  name: string;
  sys: { id: string };
}

export const LibraryCategoryShopFragment = gql`
  fragment LibraryCategoryShop on LibraryCategoryShop {
    name
    sys {
      id
    }
  }
`;
